import { render } from "./UsersEdit.vue?vue&type=template&id=c118342a"
import script from "./UsersEdit.vue?vue&type=script&lang=js"
export * from "./UsersEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__